export default {
    listId: null,
    listName: 'Web Shopping List',
    isChanged: false,
    ids: [],
    byId: {}
}
